import React from 'react';
import { Box, Typography } from '@mui/material';
import { colors } from '../design-system/tokens';

/** 페이지 상단 타이틀 + 설명 — 모든 콘솔 페이지 공통 헤더 */
const PageHeader = ({ title, description }) => (
  <Box
    sx={{
      mb: { xs: 2, sm: 2.25 },
      pb: { xs: 1.5, sm: 1.75 },
      flex: 1,
      minWidth: 0,
      borderBottom: `1px solid ${colors.border.soft}`,
    }}
  >
    <Typography
      variant="h5"
      sx={{
        color: colors.text.primary,
        fontSize: { xs: 20, sm: 22 },
        overflowWrap: 'anywhere',
      }}
    >
      {title}
    </Typography>
    {description && (
      <Typography
        variant="body2"
        sx={{
          mt: 0.5,
          color: colors.text.secondary,
          maxWidth: 760,
          overflowWrap: 'anywhere',
        }}
      >
        {description}
      </Typography>
    )}
  </Box>
);

export default PageHeader;
